import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "9 17 4 12 9 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 18v-2a4 4 0 0 0-4-4H4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Reply";
const Reply = memo(themed(Icon));
export {
  Reply
};
//# sourceMappingURL=reply.js.map
